import {UntypedFormControl} from '@angular/forms';

export function validateNumberFormat(control: UntypedFormControl) {
    const numberFormat = control.value as string;
    if (numberFormat && !(numberFormat.match(/^(-)?[0-9]*\.?[0-9]*$/))){
        return { validateNumberFormat: true };
    }
    return null;
}
